import React, { Component } from "react";
import {getNetPromoterScorePointsCategory} from './FetchCallsNetPromoterScorePointsTrackingData';

export default class AddNetPromoterScorePointsTrackingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryDropDown : [],
      selectedCategory : '',
      comments : '',
      orgId:this.props.orgId
    };
  }

  componentDidMount() {
    return getNetPromoterScorePointsCategory().then(resultList => {
      (
        this.setState({ 
          categoryDropDown : resultList,
          selectedCategory : resultList[0]
        })
      )
      });
  }

  handleComments = event => {
    this.setState({ 
      comments:event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    var payLoad = {
      category : this.state.selectedCategory,
      comments : this.state.comments,
      orgId : this.state.orgId
    }
    this.props.addNetPromoterScoreTrackingData(payLoad).then();
    this.setState({ 
      comments : '',
    });
  };

  handleStateChange = (event) => {
    this.setState({ 
      selectedCategory:event.target.value
    });
  }
  
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <h1>Add Tracking Data</h1>
                <form id="addTrackingDataForm" name="addTrackingDataForm" className="customForm"
                  ref={form => (this.addTrackingDataForm = form)}
                  onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <select autoComplete="form-control" className="npscategory" aria-required="true" placeholder="select category"
                      onChange={this.handleStateChange}
                      value = {this.state.selectedCategory}>
                      { this.state.categoryDropDown.map((category) => (<option key={category} value={category}>{category}</option>)) }
                    </select>
                  </div>
                  <div className="form-group">
                    <input id="inpCommentsText" className="form-control" aria-required="true" aria-describedby="" name="commentsText" type="text" autoComplete="nope" placeholder="Enter Comments here"
                      onChange={this.handleComments}
                      value={this.state.comments}/>
                  </div>
                  <input id="submitButton" name="submitButton" className="button secondary light-bg" type="submit" aria-label="Add Entry" value="Add Entry"/>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/firstnet/NetPromoterScore/AddNetPromoterScorePointsTrackingComponent.js